import styled from 'styled-components';

const ProgressOuterValue = styled.div`
  color: #888;
  position: absolute;
  top: 44px;
  left: 90px;
  font-weight: 700;
`;

export default ProgressOuterValue;
